import React from 'react';
import { useLocation } from 'react-router-dom';
import './Footer.css';

function Footer() {
  // Get current path from React Router
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <footer id="footer">
      <div id="sitemap">
        <div className="sitemap-col">
          <div className="logoName">
            <a href="/" className="logo" aria-label="NoetherTech Home"></a>
            <a href="/" className="companyName">NoetherTech</a>
          </div>
          <p className="footer-slogan">We don't solve mental health problems—we make them more solvable</p>
          <p>©2021-2026 Noether Sciences and Technologies Inc.<br />ALL RIGHTS RESERVED</p>
        </div>
        <div className="sitemap-col true-sitemap">
          <a href="/" className={pathname === '/' ? 'active' : ''}>Homepage</a>
          <a href="/technology" className={pathname === '/technology' ? 'active' : ''}>Technology</a>
          <a href="/science" className={pathname === '/science' ? 'active' : ''}>Science</a>
          <a href="/team" className={pathname === '/team' ? 'active' : ''}>Our Team</a>
          <a href="/history" className={pathname === '/history' ? 'active' : ''}>History</a>
        </div>
        <div className="sitemap-col">
          <p><a href="mailto:info@noethertech.com">info@noethertech.com</a></p>
          <p><a href="tel:7755057400">(775) 505-7400</a></p>
          <p>These statements have not been evaluated by the FDA, or any other regulatory agency.</p>
        </div>
      </div>
      <a id="backToTop" href="#top">&#x2191;</a>
    </footer>
  );
}

export default Footer;
